export default __webpack_public_path__ + "static/media/logo.2afc002f.png";